import { render, staticRenderFns } from "./techPersonnelList.vue?vue&type=template&id=58139628&scoped=true&"
import script from "./techPersonnelList.vue?vue&type=script&lang=js&"
export * from "./techPersonnelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58139628",
  null
  
)

export default component.exports